// extracted by mini-css-extract-plugin
export var loadingSpinner = "_40-1";
export var standaloneTable = "_40-0";